import { authActions } from "./auth-slice";
import { uiActions } from "../ui-slice";
import { logOut } from "../../utils/Guard";

export const SignIn = (auth) => {
  return async (dispatch) => {
    const formData = new URLSearchParams();

    formData.append("username", auth.email);
    formData.append("password", auth.password);

    const loginInfo = async () => {
      const response = await fetch(`${process.env.REACT_APP_URL}auth/login`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: formData,
      });

      return response;
    };
    try {
      const response = await loginInfo();

      if (response.ok) {
        dispatch(
          uiActions.showNotification({
            status: "success",
            title: "Bienvenido",
            message: "Inicio de sesión exitoso",
          })
        );

        setTimeout(() => {
          window.location.href = "/";
        }, 3500);

        const data = await response.json();

        dispatch(authActions.settoken({ token: data.access_token }));
        localStorage.setItem("token", data.access_token);

        
      } else {

        dispatch(
          uiActions.showNotification({
            status: "error",
            title: "Error!",
            message: "Verifica tu usuario y contraseña",
          })
        );
      }

    
    } catch (error) {

      dispatch(
        uiActions.showNotification({
          status: "error",
          title: "Error!",
          message: "No se pudo realizar el inicio de sesión",
        })
      );
    }
  };
};
export const RegisterUser = (user) => {
  return async (dispatch) => {
    dispatch(
      uiActions.showNotification({
        status: "pending",
        title: "Realizando nuevo registro de usuario",
        message: "Solicitando Creación del Usuario, por favor espere.",
      })
    );
    const GetUserByIdInfo = async () => {
      const response = await fetch(
        `${process.env.REACT_APP_URL}auth/register`,
        {
          method: "POST",
          body: JSON.stringify({
            name: user.name,
            last_name: user.lastName,
            email: user.email,
            password: user.password,
          }),
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      return response;
    };
    try {
      const response = await GetUserByIdInfo();

      if (response.ok) {
        dispatch(
          uiActions.showNotification({
            status: "success",
            title: "Usuario Creado",
            message: "Se ha creado el usuario exitosamente",
          })
        );
      } else {
        const message = await response.json();

        dispatch(
          uiActions.showNotification({
            status: "error",
            title: "Error!",
            message: message.detail,
          })
        );
      }
    } catch (error) {
      dispatch(
        uiActions.showNotification({
          status: "error",
          title: "Error!",
          message: "error",
        })
      );
    }
  };
};
export const ForgotMyPassword = (email) => {
  return async (dispatch) => {
    dispatch(
      uiActions.showNotification({
        status: "pending",
        title: "Enviando correo",
        message: "Solicitando correo para restablecer contraseña.",
      })
    );

    const forgotPassword = async () => {
      const response = await fetch(
        `${
          process.env.REACT_APP_URL
        }auth/forgot-password?user_email=${encodeURIComponent(email)}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      return response;
    };
    try {
      const response = await forgotPassword();

      if (response.ok) {
        dispatch(
          uiActions.showNotification({
            status: "success",
            title: "Correo enviado",
            message: "Revisa tu correo para restablecer tu contraseña",
          })
        );
      } else {
        dispatch(
          uiActions.showNotification({
            status: "error",
            title: "Error!",
            message: "ocurrió un error",
          })
        );
      }
    } catch (error) {
      dispatch(
        uiActions.showNotification({
          status: "error",
          title: "Error!",
          message: "ocurrió un error",
        })
      );
    }
  };
};
export const ChangePassword = (user) => {
  return async (dispatch) => {
    const changeUserPassword = async () => {
      const response = await fetch(
        `${process.env.REACT_APP_URL}auth/change-password`,
        {
          method: "POST",
          body: JSON.stringify({
            email: user.email,
            password: user.password,
          }),
          headers: {
            "Content-Type": "application/json",
          },
        }
      );


      return response;
    };
    try {
      const response = await changeUserPassword();

      if (response.ok) {
        dispatch(
          uiActions.showNotification({
            status: "success",
            title: "Contraseña cambiada",
            message: "Se cambió la contraseña exitosamente",
          })
        );
      } else {
        dispatch(
          uiActions.showNotification({
            status: "error",
            title: "Error!",
            message: "No se pudo cambiar la contraseña",
          })
        );
      }
    } catch (error) {

      dispatch(
        uiActions.showNotification({
          status: "error",
          title: "Error!",
          message: "Ocurrió un error",
        })
      );
    }
  };
};
export const UpdateUser = (user, id) => {
  return async (dispatch) => {
    const changeUserNames = async () => {
      const response = await fetch(
        `${process.env.REACT_APP_URL}auth/update-user-names`,
        {
          method: "PUT",
          body: JSON.stringify({
            id: id,
            name: user.name,
            last_name: user.lastName,
          }),
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      return response;
    };
    try {
      const response = await changeUserNames();

      if (response.ok) {
        dispatch(
          uiActions.showNotification({
            status: "success",
            title: "Datos actualizados",
            message: "Se actualizaron los datos exitosamente",
          })
        );
        logOut();
        window.location.href = "/login";
      } else {
        dispatch(
          uiActions.showNotification({
            status: "error",
            title: "Error!",
            message: "No se pudo cambiar los datos",
          })
        );
      }
    } catch (error) {
      dispatch(
        uiActions.showNotification({
          status: "error",
          title: "Error!",
          message: "Ocurrió un error",
        })
      );
    }
  };
};
